import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Input } from '@here/ref-client-ui';
import './autocomplete.scss';
import OutsideClickHandler from '../outsideClickHandler';
import { FORM_TYPES } from '../../../state/tabs/tab/selectedForm/constants';

function RfAutocomplete({ data, placeholder, onSelect, label, showListRegex, fullWidth,setSelectedForm }) {
  const [inputValue, setInputValue] = useState('');
  const [showList, setShowList] = useState(false);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [filteredList, setFilteredList] = useState([]);
  const lowerCasedData = data.map((val) => val.name.toLowerCase());

  const onChange = (e) => {
    let value = inputValue;
    if (e) {
      value = e.target.value;
    }
    setInputValue(value);
    setHoveredIndex(null);
    const lowerCasedValue = value.toLowerCase();
    setFilteredList(
      data.filter(
        (item, index) => lowerCasedData[index].indexOf(lowerCasedValue) !== -1 
          || item.code.toLowerCase().indexOf(lowerCasedValue) !== -1
      )
    );
    if (showListRegex.test(value)) {
      setShowList(true);
    } else {
      setShowList(false);
    }
    if (value === '') {
      onSelect(null);
    }
  };

  const select = (item) => {
    setInputValue(item);
    setShowList(false);
    setHoveredIndex(null);
    onSelect(item);
    item === "" &&  setSelectedForm(FORM_TYPES.GLOBAL);
  };

  const onKeyDown = (e) => {
    if (!showList) {
      return;
    }
    let preventDefault = false;
    // eslint-disable-next-line default-case
    switch (e.key) {
      case 'Down':
      case 'ArrowDown': {
        if (hoveredIndex === null) {
          setHoveredIndex(0);
        } else if (hoveredIndex + 1 < filteredList.length - 1) {
          setHoveredIndex(hoveredIndex + 1);
        }
        preventDefault = true;
        break;
      }
      case 'Up':
      case 'ArrowUp': {
        if (hoveredIndex === 0) {
          setHoveredIndex(null);
        } else if (hoveredIndex > 0) {
          setHoveredIndex(hoveredIndex - 1);
        }
        preventDefault = true;
        break;
      }
      case 'Enter':
        if (hoveredIndex !== null) {
          e.target.blur();
          select(filteredList[hoveredIndex].code);
        }
        preventDefault = true;
        break;
      case 'Esc':
      case 'Escape':
        e.target.blur();
        setShowList(false);
        setHoveredIndex(null);
        preventDefault = true;
        break;
    }
    if (preventDefault) {
      e.preventDefault();
    }
  };
  
  return (
    <OutsideClickHandler
      outsideClick={() => setShowList(false)}
      cssClasses="rf-filter-input"
    >
      {inputValue.length !== 0 && <span className='rf-filter-input-clear' onClick={() => select("")} >X</span>}
      <Input
        label={label}
        value={inputValue}
        onChange={onChange}
        placeholder={placeholder}
        onFocus={onChange}
        onKeyDown={onKeyDown}
        autoComplete="none"
      />
      {showList && (
        <ul className={fullWidth ? 'rf-country-filter' : null} >
          {filteredList.map((item, index) => (
            <li
              key={item.code}
              onClick={() => select(item.code)}
              className={
                index === hoveredIndex ? 'rf-filter-input__item_hovered' : null
              }
            >
              {`${item.name} - ${item.code}`}
            </li>
          ))}
        </ul>
      )}
    </OutsideClickHandler>
  );
}

RfAutocomplete.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
  onSelect: PropTypes.func,
  data: PropTypes.array,
  showListRegex: PropTypes.object,
  fullWidth: PropTypes.bool
};

export default RfAutocomplete;
